import { render, staticRenderFns } from "./ShuQi.vue?vue&type=template&id=2bc1edc6&scoped=true&"
import script from "./ShuQi.vue?vue&type=script&lang=js&"
export * from "./ShuQi.vue?vue&type=script&lang=js&"
import style0 from "./ShuQi.vue?vue&type=style&index=0&id=2bc1edc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc1edc6",
  null
  
)

export default component.exports